import moment from "moment";

import { PatientConsentModel } from "@/Common/Api/Patient/Dto/PatientConsentModel";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";

interface ILegacyPatientConsentProgramsProps {
    items: Immutable.List<PatientConsentModel>;
    readOnly?: boolean;
}

const LegacyPatientConsentPrograms: React.FC<ILegacyPatientConsentProgramsProps> = ({ items, readOnly }: ILegacyPatientConsentProgramsProps): JSX.Element => {
    const { getText } = useTranslation();

    if (!items?.count()) {
        return <></>;
    }

    let render = PatientHelper.sortConsentPrograms(items.toArray()).map(consent => (
        <tr key={consent.Id}>
            <td>
                <div style={{ marginRight: "10px", wordBreak: "break-all" }}>
                    {sessionStore.userLanguageCode == "fr" &&
                        <strong>{consent.NameFr}</strong>
                    }
                    {sessionStore.userLanguageCode == "en" &&
                        <strong>{consent.NameEn}</strong>
                    }
                    {sessionStore.userLanguageCode == "es-MX" &&
                        <strong>{consent.NameEs}</strong>
                    }
                </div>
            </td>
            <td>
                {consent.IsDocGiven == true &&
                    <label>{getText("DocGivenLabel")} ({moment(consent.DocGivenDate).format("YYYY/MM/DD")}) </label>
                }
                {consent.IsDocGiven == false &&
                    <label>{getText("NoDocNeededLabel")}</label>
                }
            </td>
            <td style={{ paddingLeft: "10px" }}>
                {(consent.HasConsentment != null && consent.HasConsentment == false) && (
                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                        <span className="glyphicon glyphicon-remove red-text" style={{ marginRight: "5px" }} />
                        <span>{getText("RefusalLabel")} ({moment(consent.ConsentDate).format("YYYY/MM/DD")})</span>
                    </div>
                )}
                {(consent.HasConsentment != null && consent.HasConsentment == true) && (
                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                        <span className="glyphicon glyphicon-ok green-text" style={{ marginRight: "5px" }} />
                        <span>{getText("ConsentLabel")} ({moment(consent.ConsentDate).format("YYYY/MM/DD")})</span>
                    </div>
                )}
                {(consent.HasConsentment == null) && (
                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                        <span className="glyphicon glyphicon-exclamation-sign orange-text" style={{ marginRight: "5px" }} />
                        <span>{getText("DidntRespondLabel")} {consent.ConsentDate ? `(${moment(consent.ConsentDate).format("YYYY/MM/DD")})` : ""}</span>
                    </div>
                )}
            </td>
            <td>
                {(consent.HasRevoked != null && consent.HasRevoked == true) && (
                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                        <span className="glyphicon glyphicon-remove red-text" style={{ marginRight: "5px" }} />
                        <span>{getText("RevokedConsentLabel")} ({moment(consent.RevokedDate).format("YYYY/MM/DD")}) </span>
                    </div>
                )}
                {(consent.HasRevoked == null || consent.HasRevoked == false) &&
                    <span>--</span>
                }
            </td>
            {!readOnly && (
                <td>
                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                        <a style={{ paddingRight: "5px" }} onClick={() => sessionStore.dispatch(LocalPatientOperations.Profile.OtherInfo_ModifyConsentClick, { value: consent.Id })}>{getText("ModifyLabel")}</a>
                    </div>
                </td>
            )}
        </tr>
    ));

    return (
        <div className="flex-container center">
            <div className="psingle-column centered-consent">
                <table>
                    <tbody>
                        {render}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export { LegacyPatientConsentPrograms };
